module.exports = __webpack_public_path__ + "img/sweden_mountain.4ee7ba2f.jpg";